// extracted by mini-css-extract-plugin
export var wrapper = "Event-module--wrapper--UsNKB";
export var item = "Event-module--item--4xKAs";
export var more = "Event-module--more--36A5l";
export var imgbox = "Event-module--imgbox--3J1bO";